import { get } from 'lodash';

const theWindow = typeof window !== 'undefined' ? window : {};
const HOST =
    get(theWindow, 'ZD.configs.API_DOMAIN') ||
    process.env.AWS_API_HOST ||
    'https://api.zocdoc.com';

export default function getAwsApiHost() {
    return HOST;
}
